'use strict';
define('elements/navigation__map',['jquery'], function ($) {

    var $mapItems = $('[data-map]'),
        $target = $('.dropdown__map');

    $mapItems.each(function () {
        var $item = $(this),
            map = $item.data('map');

        $item.mouseenter(function () {
            $target.addClass('dropdown__map--' + map);
        });

        $(this).mouseleave(function () {
            $target.removeClass('dropdown__map--' + map);
        });
    });
});
